/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createStyles } from "@material-ui/core";

export const styles = ({ spacing, breakpoints } ) => createStyles({
    header: {
        marginBottom: spacing.unit * 6
    },
    container: {
        maxWidth: 1024,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: spacing.unit * 8,
        marginBottom: spacing.unit * 8,
        [breakpoints.down(1100)]: {
            marginLeft: `${spacing.unit * 5}px`,
            marginRight: `${spacing.unit * 5}px`,
            width: "calc(100% - 80px)",
        }
    },
    title: {
        textTransform: "uppercase"
    }
});


// WEBPACK FOOTER //
// ./src/pages/PageQuotation/PageQuotation.style.tsx